import { render, staticRenderFns } from "./RepresentationSection.vue?vue&type=template&id=4c06a194"
import script from "./RepresentationSection.vue?vue&type=script&lang=js"
export * from "./RepresentationSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports